export const firebaseFields = {
  headersId: "00aaaaaaaaaaaaaaaaaaaa",
  collections: "tables",
  accounts: "accounts",
  users: "users",
};
